import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { authRoles } from 'app/auth';

import CampaignListLayout from './layouts/CampaignListLayout';

const BroadcastsList = lazy(() => import('./broadcasts/use-cases/broadcasts-list'));
const CreateBroadcast = lazy(() => import('./broadcasts/use-cases/create-broadcast'));

const HowSmsCampaignWorks = lazy(() => import('./sms/use-cases/how-it-works/HowSmsCampaignWorks'));
const CreateSignUpCampaign = lazy(() => import('./sms/use-cases/create-sign-up-campaign'));
const SMSCampaignsTable = lazy(() => import('./sms/use-cases/campaigns-table'));
const ResendCampaign = lazy(() => import('./sms/use-cases/resend-campaign'));
const SignUpCampaigns = lazy(() => import('./sms/use-cases/sign-up-campaigns'));

const MarketingCampaignsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
            background: 'featured',
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'campaigns',
      element: <CampaignListLayout />,
      children: [
        {
          path: '',
          element: <Navigate to="/campaigns/broadcasts" replace />,
        },
        {
          path: 'sms',
          element: <SMSCampaignsTable />,
        },
      ],
    },
    {
      path: 'campaigns/sms/how-it-works',
      element: (
        <HowSmsCampaignWorks
          onStartCampaign={() => {
            console.log('start campaign');
          }}
        />
      ),
    },
    {
      path: 'campaigns/:campaignId/resend',
      element: <ResendCampaign />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'campaigns/sms/create-sign-up-campaign',
      element: <CreateSignUpCampaign />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: false,
              },
            },
          },
        },
      },
    },
    {
      path: 'campaigns/sms/sign-up-campaigns',
      element: <SignUpCampaigns />,
    },
    {
      path: 'campaigns/broadcasts',
      element: <BroadcastsList />,
      auth: authRoles.pharmacist,
    },
    {
      path: 'campaigns/broadcasts/create',
      element: <CreateBroadcast />,
      auth: authRoles.pharmacist,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                // Mounted but hidden so pharmacy selection still initialises on direct page load
                pharmacySelector: true,
                pharmacySelectorHidden: true,
              },
            },
          },
        },
      },
    },
    // Old routes re-write
    {
      path: 'broadcast',
      element: <Navigate to="/campaigns/broadcasts" replace />,
    },
    {
      path: 'broadcast/create',
      element: <Navigate to="/campaigns/broadcasts/create" replace />,
    },
  ],
};

export default MarketingCampaignsConfig;
